import React, { Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetActivity } from '../../../store/ActivityAction';
import { useParams, Link, Route, Routes, Navigate } from 'react-router-dom'
import * as Tab from '../../../util/TabValue';
import RenderTabs from '../../misc/Tabs';
import ActivityViewInfo from './ActivityViewInfo';
import ActivityViewGroups from './ActivityViewGroups';
import ActivityViewTrackings from './ActivityViewTrackings';
import ActivityViewObjectLogs from './ActivityViewObjectLogs';
import ActivityViewMembers from './ActivityViewMembers';
import ActivityViewSyllabus from './ActivityViewSyllabus';
import NotFound from '../components/NotFound';
import { CoreActivity } from '../../../models/CoreActivity';
import { RequestState } from '../../../models/RequestState';
import StatusCode from '../../../util/StatusCode';
import Loading from '../../misc/Loading';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/store';
import DeleteDate from '../../misc/DeleteDate';
import * as Helper from '../../../util/Helper';


const ActivityView = () => {
    const { t } = useTranslation('common');
    const { activityId } = useParams();
    const dispatch = useDispatch();
    const activity = useSelector<RootState, RequestState<CoreActivity>>(state => state.activities.activity);

    useEffect(() => {
        if (activityId !== undefined) {
            GetActivity(activityId)(dispatch);
        }
    }, [dispatch, activityId]);

    const tabs = [
        Tab.Tabs.Information,
        Tab.Tabs.ObjectLogs,
        Tab.Tabs.Members,
        Tab.Tabs.Groups,
        Tab.Tabs.Syllabus,
        Tab.Tabs.Trackings,
    ];

    if (activityId === undefined) {
        return;
    }

    const renderContent = (body: any) => (
        <div className="padding-40 container single">
            <h1><Link to="/activity">{t('object.schoolAdmin.activity_one', { ns: 'common' })}</Link> {displayName}</h1>
            {body}
        </div>
    )

    let displayName: string | undefined = '';

    switch (activity.code) {
        case StatusCode.COMPLETE:
            displayName = activity.data.displayName;
            return (renderContent(<>

                {activity.data.removeDate && <DeleteDate message={t('deleteDate.activity', { ns: 'schoolAdministration', date: Helper.formatDateOnly(activity.data.removeDate) })} />}

                <RenderTabs
                    tabs={tabs}
                    id={activityId}
                    url="activity" />

                <Suspense fallback={<Loading />}>
                    <Routes>
                        <Route path={Tab.Tabs.Information.url} element={<ActivityViewInfo />} />
                        <Route path={Tab.Tabs.ObjectLogs.url} element={<ActivityViewObjectLogs />} />
                        <Route path={Tab.Tabs.Members.url} element={<ActivityViewMembers />} />
                        <Route path={Tab.Tabs.Groups.url} element={<ActivityViewGroups />} />
                        <Route path={Tab.Tabs.Syllabus.url} element={<ActivityViewSyllabus />} />
                        <Route path={Tab.Tabs.Trackings.url} element={<ActivityViewTrackings />} />
                        <Route path="*" element={<Navigate replace={true} to={`/activity/${activityId}/${Tab.Tabs.Information.url}`} />} />
                    </Routes>
                </Suspense>
            </>));
        case StatusCode.ERROR:
            if (activity.error.response?.status === 404 || activity.error.response?.status === 400) {
                return (
                    <NotFound
                        header={t('object.schoolAdmin.activity', { ns: 'common', count: 1 })}
                        translateKey={{ i18nKey: "notFound.activity", ns: "schoolAdministration" }}
                        link="/activity"
                    />
                );
            } else {
                return renderContent(<p>{activity.error.response?.statusText}</p >);
            }
        default:
            return (renderContent(<Loading />));
    }
}

export default ActivityView;
